export default {
      id: "show-usage",
      viewBox: "0 0 19 14",
      url: __webpack_public_path__ + "icons-sprite.03ac376.svg#show-usage",
      toString: function () {
        return this.url;
      }
    }